import Account from '@/orm/models/Account/Account';
import { computed } from '@vue/composition-api';

export default function useSubscription() {
  const account = computed(() => Account.query().withAllRecursive().first());

  const subscriptionStatus = computed(() => account.value?.subscriptionEnabled);

  const isExpired = computed(() => Boolean(account.value && !account.value.active));

  const hasFailedRenewal = computed(() => account.value?.hasFailedRenewal);

  function cancelSubscription() {
    return Account.api().cancelSubscription();
  }

  function renewActiveSubscription() {
    return Account.api().renewActiveSubscription();
  }

  function renewSubscriptionOnDefaultPlan() {
    return Account.api().renewSubscriptionOnDefaultPlan();
  }

  return {
    cancelSubscription,
    renewActiveSubscription,
    renewSubscriptionOnDefaultPlan,
    isExpired,
    subscriptionStatus,
    hasFailedRenewal,
  };
}
